import { connect } from 'react-redux'
import selectors from 'selectors'
import userActions from 'actions/users'
import Component from 'components/DashboardThemes/Filter'

const mapStateToProps = (state, props) => ({ users: selectors.users.selectOptions(state) })

const mapDispatchToProps = (dispatch, props) => ({
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
